import React, { useEffect, useState } from "react";
import Header from "../layouts/Header";
import Banner from "../components/socialResponsibility/Banner";
import Footer from "../layouts/Footer";
import Event from "../components/socialResponsibility/event";
import Impacts from "../components/socialResponsibility/impacts";
import JoinOurTeam from "../components/Home/JoinOurTeam";
import UnlockPotential from "../components/career/UnlockPotential";
import { motion } from "motion/react";
import { Helmet } from "react-helmet";

const CorpSocialResponsibility = () => {
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
    const timer = setTimeout(() => setHasLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: hasLoaded ? 1 : 0 }}
      transition={{ duration: 0.7 }}
    >
      <Helmet>
        <title>Volto Consulting | Business &amp; Technology Solutions</title>
        <meta
          name="description"
          content="Volto Consulting provides innovative business and technology solutions to drive success in a digital world."
        />
        <meta
          name="keywords"
          content="Volto Consulting, business consulting, IT solutions, technology strategy, digital transformation"
        />
        <meta name="author" content="Volto Consulting" />
        <meta
          property="og:title"
          content="Volto Consulting | Business &amp; Technology Solutions"
        />
        <meta
          property="og:description"
          content="Volto Consulting offers expert business and IT consulting services to enhance your digital transformation journey."
        />
      </Helmet>
      <div className="volto-homepage csr">
        <Header  mode="light"/>
        <Banner />
        <Event />
        <Impacts />
        <UnlockPotential />
        <JoinOurTeam  image={"/images/join-our-team.webp"}/>
        <Footer />
      </div>
    </motion.div>
  );
};

export default CorpSocialResponsibility;
